import * as React from 'react';
import { DecoratorNode } from 'lexical';

import BlockComponent from './BlockComponent';

export class BlockNode extends DecoratorNode {
  static getType() {
    return 'block';
  }

  static clone(node) {
    return new BlockNode(node.__data, node.__key);
  }

  static importJSON(serializedNode) {
    return $createBlockNode(serializedNode.data);
  }

  constructor(data, options, key) {
    super(key);
    this.__data = data;
  }

  exportJSON() {
    return {
      data: this.__data,
      type: 'block',
      version: 1
    };
  }

  createDOM() {
    const elem = document.createElement('span');
    elem.style.display = 'inline-block';
    elem.style.maxWidth = '100%';
    return elem;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return <BlockComponent data={this.__data} nodeKey={this.__key} />;
  }
}

export function $createBlockNode(data, opts = {}) {
  return new BlockNode(data, opts);
}

export function $isBlockNode(node) {
  return node instanceof BlockNode;
}
